const defaults = {
	globVar : [ // List of all possible global vars to read from page
		's_account',
		's_site',
		's_linkTrackVars',
		's_linkTrackExtend',
		's_context',
		's_page_state',
		's_pagename',
		's_pageurl',
		's_not_pageview',
		's_pagenum',
		's_registered_user_id',
		's_user_group',
		's_user_origin',
		's_auth_channel_id',
		's_profession_id',
		's_user_specialty',
		's_user_specialty_id',
		's_user_occupation_id',
		's_pageview_id',
		's_cname',
		's_regidtemp',
		's_channel'
	],
	globReqDefault : { // Default values for variables which may or may not be printed on page
		s_linkTrackVars: 'contextData.wb.pvid,contextData.wb.mpvid,contextData.wb.lnktxt,contextData.wb.vapi,contextData.wb.chn,contextData.wb.contypeid,contextData.wb.toolin,contextData.wb.dprofsn,contextData.wb.dprofsnid,contextData.wb.dcntry,contextData.wb.dspclty,contextData.wb.dspcltyid,contextData.wb.sact,contextData.wb.sactid,contextData.wb.sprod,contextData.wb.sprodid,contextData.wb.sptr,contextData.wb.site,contextData.wb.regid,contextData.wb.vdname,contextData.wb.audioflg,contextData.wb.rspd,contextData.wb.brkpt,contextData.wb.mmodule,contextData.wb.mlink,contextData.wb.mpage,contextData.wb.ldcncptid,contextData.wb.mldncptid,contextData.wb.ldcncpt,contextData.wb.ldspecid,contextData.wb.cstm,contextData.wb.dwnld,contextData.wb.exiturl,contextData.wb.mpgtitle,contextData.wb.msact,contextData.wb.msactid,contextData.wb.msprod,contextData.wb.msprodid,contextData.wb.msptr,contextData.wb.sfid,contextData.wb.msfid,contextData.wb.chn,eVar1,contextData.wb.authchn,contextData.wb.pratset,contextData.wb.payer,contextData.wb.respon,contextData.wb.interest,contextData.wb.regdate,contextData.wb.regsite,contextData.wb.hcpvalid,contextData.wb.acctstatid,contextData.wb.profstate,contextData.wb.age,contextData.wb.gender,contextData.wb.zip,contextData.wb.mpctvw,contextData.wb.asset,contextData.wb.actid,contextData.wb.instid,contextData.wb.expandedbrandid,contextData.wb.salesforcedeliverableid,contextData.wb.salesforcedeliverablename,contextData.wb.gdprauth,contextData.wb.cmsid,contextData.wb.actidall,contextData.wb.testuser,contextData.wb.srvlog,contextData.wb.bundleid,server,contextData.wb.huid,contextData.wb.npi',
		s_account: 'webmdp1global',
		s_pagenum: "0"
	},
	ctxVarMap : { // Mapping of page variables -> contextData variables. Optional '_default'-affixed key names can be used for cases when value is not present on page but should be set anyway
		'wb.regid': 's_registered_user_id',
		'wb.regid_default': '000000000',
		'wb.pvid': 's_pageview_id',
		'wb.authchn': 's_auth_channel_id',
		'wb.dprofsnid': 's_profession_id',
		'wb.dprofsn': 's_user_group',
		'wb.dspcltyid': 's_user_specialty_id',
		'wb.dspclty': 's_user_specialty',
		'wb.doccptnid': 's_user_occupation_id',
		'wb.pagination': 's_pagenum',
		'wb.dcntry': 's_user_origin',
		'wb.chn': 's_channel'
	},
	pageMetaKeyMap : { // Context variable mappings specific to 'PageMetadata' object
		'wb.ppubid': 'pageSegVars.pub',
		'wb.ldcncptid': 'pageSegVars.scg',
		'wb.ldcncpt': 'pageSegVars.scg_name',
		'wb.ldspecid': 'pageSegVars.ssp',
		'wb.contypeid': 'pageSegVars.ctype',
		'wb.dtpost': 'pageSegVars.pdt',
		'wb.dtreview': 'pageSegVars.udt',
		'wb.dtpub': 'pageSegVars.pbdt',
		'wb.sactid': 'pageSegVars.act',
		'wb.scollctid': 'pageSegVars.coll',
		'wb.sprodid': 'pageSegVars.prd',
		'wb.sptr': 'pageSegVars.sptr',
		'wb.ppubgid': 'pageSegVars.ppubsc',
		'wb.regid': 'userSegVars.gd',
		'wb.dspcltyid': 'userSegVars.usp',
		'wb.dprofsnid': 'userSegVars.pf',
		'wb.doccptnid': 'userSegVars.occ',
		'wb.dcntry': 'userSegVars.ct',
		'wb.actidall': 'userSegVars.actid',
		'wb.site': 'trackSegVars.site',
		'wb.asset': 'pageSegVars.asst',
		'wb.cmsid': 'pageSegVars.cmsid',
		'wb.authchn': 'authVar.authenticationChannel',
		'wb.pratset': 'addProfile.ps',
		'wb.payer': 'addProfile.pst',
		'wb.respon': 'addProfile.resIds',
		'wb.interest': 'addProfile.intIds',
		'wb.regdate': 'addProfile.regdate',
		'wb.regsite': 'addProfile.regsite',
		'wb.hcpvalid': 'userSegVars.val',
		'wb.acctstatid': 'addProfile.acctstatid',
		'wb.profstate': 'addProfile.profstate',
		'wb.age': 'addProfile.age',
		'wb.gender': 'addProfile.gender',
		'wb.zip': 'addProfile.zip',
		'wb.testuser': 'addProfile.test',
		'wb.srvlog': 'extraObject.csStatus',
		'wb.huid': 'userSegVars.huid',
		'wb.npi': 'userSegVars.dt'
	},
	userMetaKeys : ['wb.regid',
		'wb.dspcltyid',
		'wb.dspclty',
		'wb.dprofsnid',
		'wb.dprofsn',
		'wb.doccptnid',
		'wb.dcntry',
		'wb.actidall',
		'wb.pratset',
		'wb.payer',
		'wb.respon',
		'wb.interest',
		'wb.regdate',
		'wb.regsite',
		'wb.hcpvalid',
		'wb.acctstatid',
		'wb.profstate',
		'wb.age',
		'wb.gender',
		'wb.zip',
		'wb.npi',
		'wb.tpi',
		'wb.gdprauth',
		'wb.testuser',
		'wb.huid',
		'wb.npi'
	],
	referVals : [ // List of variables which should have a corresponding referring-page 'm'-prefixed context var in module-tracking calls, e.g - placing 'wb.sptr' here populates 'wb.msptr' into module-tracking calls
		'wb.pvid',
		'wb.pgtitle',
		'wb.sptr',
		'wb.sact',
		'wb.sactid',
		'wb.sprod',
		'wb.sprodid',
		'wb.sfid',
		'wb.ldcncptid',
		'wb.contypeid',
		'wb.pctvw'
	],
	sOvrRide : [ // List of 's_' variables to read from page, which overwrite any previously-set contextData variables. Variables are sent as contextData, where 's_' is replaced by 'wb.' - e.g. 's_sactid' will be sent as 'wb.sactid'
		's_sactid',
		's_sact',
		's_scollctid',
		's_sprodid',
		's_sprod',
		's_sptr',
		's_asset',
		's_contypeid',
		's_sfid',
		's_regid',
		's_dcntry',
		's_dprofsnid',
		's_dspcltyid',
		's_regidtemp'
	],
	promoOvrRide : [ 
		's_sactid',
		's_sact',
		's_sprodid',
		's_sprod',
		's_sptr'
	],
	lowerCaseOvrRide : [ 
		'wb.tpi',
		'wb.actid',
		'wb.instid',
		'wb.expandedbrandid',
		'wb.salesforcedeliverableid'
	],

	chkOnEachTrackCall : [ // List of context vars to re-check from global scope each time a tracking call fired, e.g. 'wb.pvid', where 's_pageview_id' may change during session
		'wb.pvid'
	],
	removeQuoteIn: [ // List of context vars which should have single-quote removed
		'wb.query',
		'wb.querytext',
		'wb.sptr',
		'wb.sact',
		'wb.sprod'
	],
	allowZero : [ 
		'val',
		'profstate'
	]
}
		
export default defaults;
